<template>
  <div class="template">
    <div class="search">
      <div>
        <Input
          v-model="search.search_name"
          placeholder="请输入标题"
          style="width: 310px; margin-right: 10px"
          icon="ios-search"
        ></Input>
        <Button style="width: 90px" type="primary" icon="ios-search" @click="searchFn">搜索</Button>
      </div>
      <Button type="primary" icon="ios-add" @click="$router.push({ name: 'add-competition' })">创建赛事</Button>
    </div>
    <div class="table">
      <Table border :columns="diyData.columns" :data="apiData.tableList">
        <template slot="footer">
          <Page
            :total="apiData.total"
            show-total
            :page-size="apiData.per_page"
            :current="search.page"
            class-name="footer-page"
            @on-change="pageChange"
          ></Page>
        </template>
      </Table>
    </div>
    <Modal v-model="diyDom.showCode" title="赛事二维码" footer-hide>
      <div class="model-content" style="text-align: center; margin: 30px auto">
        <img :src="apiData.qrcode" style="margin: 0 auto; width: 150px; height: 150px" alt="" />
        <div class="tips" style="margin-top:10px;">使用微信扫码</div>
      </div>
    </Modal>
  </div>
</template>

<script>
import * as apiCompetition from '@/api/activity/competitions'
import * as apiProgramCode from '@/api/activity/index'
import downloadBlob from '@/utils/downloadBlob'
export default {
  name: 'competitionList',
  data () {
    return {
      query: {},
      search: {
        search_name: '',
        page: 1
      },
      diyDom: {
        showCode: false
      },
      diyData: {
        columns: [
          {
            title: 'ID',
            width: 90,
            fixed: 'left',
            render: (h, params) => {
              return h('div', params.index + 1)
            }
          },
          {
            title: '活动标题',
            key: 'title',
            fixed: 'left',
            width: 240
          },
          {
            title: '主办单位',
            key: 'host',
            width: 180
          },
          {
            title: '协办单位',
            key: 'organizer',
            width: 180
          },
          {
            title: '指导单位',
            key: 'guidance_unit',
            width: 180
          },
          {
            title: '承办单位',
            key: 'undertake',
            width: 180
          },
          {
            title: '赛事运营方',
            key: 'operate',
            width: 180
          },
          {
            title: '报名时间',
            width: 180,
            render: (h, params) => {
              return h('div', [
                h('div', `起：${params.row.registration_start_time}`),
                h('div', `止：${params.row.registration_end_time}`)
              ])
            }
          },
          {
            title: '活动时间',
            width: 180,
            render: (h, params) => {
              return h('div', [h('div', `起：${params.row.start_time}`), h('div', `止：${params.row.end_time}`)])
            }
          },
          {
            title: '报名数量',
            key: 'real_count',
            width: 180
          },
          {
            title: '排序',
            key: 'sort',
            width: 180
          },
          {
            title: '状态',
            key: 'registration_status_lab',
            width: 180
          },
          {
            title: '操作',
            fixed: 'right',
            width: 140,
            render: (h, params) => {
              return h('div', [
                h(
                  'a',
                  {
                    style: {
                      marginRight: '10px',
                      color: '#2D8cF0'
                    },
                    on: {
                      click: () => {
                        this.$router.push({
                          name: 'competition-signup-list',
                          query: {
                            com_id: params.row.id
                          }
                        })
                      }
                    }
                  },
                  '报名列表'
                ),
                h(
                  'a',
                  {
                    style: {
                      marginRight: '10px',
                      color: '#2D8cF0'
                    },
                    on: {
                      click: () => {
                        this.$router.push({
                          name: 'add-competition',
                          query: {
                            id: params.row.id
                          }
                        })
                      }
                    }
                  },
                  '编辑'
                ),
                h(
                  'a',
                  {
                    style: {
                      marginRight: '10px',
                      color: '#2D8cF0'
                    },
                    on: {
                      click: () => {
                        this.$store.commit('setSpinShow', true)
                        apiCompetition
                          .apiCompetitionsSignExportAll(params.row.id, {
                            t: new Date().getTime()
                          })
                          .then(res => {
                            downloadBlob(res)
                          })
                          .finally(() => this.$store.commit('setSpinShow', false))
                      }
                    }
                  },
                  '下载报名'
                ),

                h(
                  'a',
                  {
                    style: {
                      marginRight: '10px',
                      color: 'red'
                    },
                    on: {
                      click: () => {
                        this.$Modal.confirm({
                          title: '提示',
                          content: '请确认是否删除当前数据？',
                          onOk: () => {
                            apiCompetition.apiCompetitionsDetele(params.row.id).then(res => {
                              this.$Message.success('已删除')
                              this.getTableList()
                            })
                          }
                        })
                      }
                    }
                  },
                  '删除'
                ),
                h(
                  'a',
                  {
                    style: {
                      marginRight: '10px'
                    },
                    on: {
                      click: () => {
                        apiProgramCode
                          .apiGetProgramCode({
                            type: 2,
                            id: params.row.id
                          })
                          .then(res => {
                            const { url } = res.data
                            this.apiData.qrcode = url
                            this.diyDom.showCode = true
                          })
                      }
                    }
                  },
                  '获取二维码'
                )
              ])
            }
          }
        ]
      },
      apiData: {
        total: 0,
        per_page: 0,
        tableList: [],
        qrcode: '' // 小程序二维码
      }
    }
  },
  methods: {
    // 获取表格数据
    getTableList () {
      this.$store.commit('setSpinShow', true)
      apiCompetition
        .apiCompetitionsList({ ...this.search })
        .then(res => {
          const { data, meta } = res
          this.apiData.tableList = data
          this.apiData.per_page = meta.pagination.per_page
          this.apiData.total = meta.pagination.total
        })
        .finally(() => this.$store.commit('setSpinShow', false))
    },
    // 分页
    pageChange (e) {
      this.search.page = e
      this.getTableList()
    },
    // 搜索
    searchFn () {
      this.search.page = 1
      this.getTableList()
    },
    // 清空
    clearFn () {
      this.search = {
        search_name: '',
        page: 1
      }
      this.getTableList()
    }
  },
  mounted () {
    this.getTableList()
  }
}
</script>

<style scoped lang="less">
  .template {
    .search {
      display: flex;
      justify-content: space-between;
    }
    .table {
      margin-top: 10px;
    }
    .filter {
      margin: 10px 0;
      display: flex;
      justify-content: left;
      align-items: center;
      padding: 6px 0 20px 0;
      flex-wrap: wrap;
      border: 1px solid rgba(237, 237, 237, 1);

      .filter-item {
        margin: 14px 0 0 20px;

        .title {
          margin-right: 10px;
          font-size: 12px;
          font-weight: 400;
          color: rgba(74, 74, 74, 1);
          line-height: 17px;
        }
      }
    }
  }
</style>
